import * as styles from 'styles/pages/About.css'
import * as textStyles from 'styles/atoms/Text.css'
import Anchor from 'components/atoms/navigation/Anchor'
import { ExternalPageHeading } from 'components/atoms/Text'
import { CONTACT_EMAIL } from 'constants/email'
import ExternalLayout from 'components/features/external/ExternalLayout/ExternalLayout'
import { GOOGLE_MAPS_API_KEY } from 'constants/api'
import { EmailLink } from 'components/features/pfm/EmailLink/EmailLink'
import { PageMeta } from 'components/features/pfm/PageMeta/PageMeta'

const MAP_SOURCE = `https://www.google.com/maps/embed/v1/place?key=${ GOOGLE_MAPS_API_KEY }&q=79+Madison+Ave+Suite+930,New+York+NY&zoom=12`

const About = () => (
  <Anchor placement='about'>
    <PageMeta
      title='About Status Money'
      description='Financial insights & advice for all'
    />
    <ExternalLayout
      type='common'
      isSingleColumn
    >
      <section className={ styles.section }>
        <ExternalPageHeading>Our Story</ExternalPageHeading>
        <h4 className={ styles.subtitle }>
          We are the American dream.
        </h4>

        <p className={ styles.paragraph }>
          Founded by an immigrant and a first-generation American, Status Money was created to give everyone the chance to get ahead financially.
        </p>

        <p className={ styles.paragraph }>
          The founders are both data scientists that spent their careers working at financial institutions including Citi and Goldman Sachs. They observed firsthand how legacy banks systemically reward the wealthy and disadvantage those aspiring to get ahead.
        </p>

        <p className={ styles.paragraph }>
          They envisioned a better bank. One that's anchored in giving everyone the tools, advice, and products they need to achieve their financial goals – regardless of their age, income, or net worth.
        </p>

        <p className={ styles.paragraph }>
          Our journey started with a social financial management app – the first to enable members to compare finances with peers and video chat with advisors.
        </p>

        <p className={ styles.paragraph }>
          We’re now building a suite of banking products that help members build wealth automatically. Because that’s how it should have been all along.
        </p>

        <p className={ styles.paragraph }>
          Let’s get ahead together.
        </p>
      </section>

      <section className={ styles.section }>
        <h2 className={ textStyles.externalPageHeading }>
          Contact Us
        </h2>

        <p className={ styles.paragraph }>
          <EmailLink email={ CONTACT_EMAIL } />
        </p>

        <p className={ styles.paragraph }>
          Status Money <br />
          79 Madison Ave. Suite 930 <br />
          New York, NY 10016
        </p>
      </section>

      <div className={ styles.mapWrapper } data-qa-marker='map-section'>
        <iframe
          src={ MAP_SOURCE }
          width='100%'
          height='100%'
          frameBorder='0'
          style={{ border: 0 }}
          allowFullScreen
        />
      </div>
    </ExternalLayout>
  </Anchor>
)

export default About
